module.exports = __webpack_public_path__ + "static/media/img_snake_flex_bottom_right.6d44f83e.svg";